import React from 'react';

const ConciliacaoBancariaContext = React.createContext();

export default ConciliacaoBancariaContext;
